import { connect } from 'react-redux';
import { closeSideBar } from '../../../../store/sidebar';
import { Instances } from '../../../../constants';
import { makeSelectInProgress, makeSelectObject, requestObject } from '../../../../store/Object';
import { IStateType } from '../../../../store/models/root.interface';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import verifiedSMSView, { DispatchPropsType, MapStatePropsType } from '../organisms/verifiedSMS/viewVerifiedSMS';

const mapStateToProps = (state: IStateType) => ({
    templateViewDetails: makeSelectObject(Instances.smsVerifiedSMS)(state) || {},
    inProgress: makeSelectInProgress(Instances.smsVerifiedSMS)(state),
    data: state.smsVerifiedSMS
});

const mapDispatchToProps = {
    onClose: () => closeSideBar(),
    onLoad: () => requestObject(Instances.smsVerifiedSMS)
};

export default connect<MapStatePropsType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(verifiedSMSView));